import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import * as tribunalAPI from '@debbie/cortex/dist/api/tribunal.js';
import { DKTribunalJobType } from '@debbie/common/dist/tribunal/jobs/countries/denmark.js';
import { GLTribunalJobType } from '@debbie/common/dist/tribunal/jobs/countries/greenland.js';
import q from '@debbie/cortex/dist/query.js';
import { tribunalJobsEntity } from '@debbie/cortex/dist/tribunal/index.js';
import keys from '@debbie/common/dist/cache/keys.js';
import { DateInput, Button } from '../../../index.js';
const RegisterInsolvency = (props) => {
    const lang = useSelector((s) => s.lang);
    const [loading, setLoading] = useState(false);
    const [insolvencyDate, setInsolvencyDate] = useState(moment());
    const registerInsolvency = async () => {
        setLoading(true);
        try {
            if (props.isGreenland) {
                await tribunalAPI.createTribunalJob({
                    type: GLTribunalJobType.RegisterInsolvens,
                    tribunalCaseId: props.tribunalCase.id,
                    data: {
                        insolvencyDate: insolvencyDate?.toISOString(),
                    },
                    caseId: props.tribunalCase.caseId,
                    reference: `${props.tribunalCase.reference || 'FS'}`.trim(),
                });
            }
            else {
                await tribunalAPI.createTribunalJob({
                    type: DKTribunalJobType.RegisterInsolvency,
                    tribunalCaseId: props.tribunalCase.id,
                    data: {
                        insolvencyDate: insolvencyDate?.toISOString(),
                    },
                    caseId: props.tribunalCase.caseId,
                    reference: `${props.tribunalCase.reference || 'FS'}`.trim(),
                });
            }
            props.onSubmit();
        }
        catch (err) {
            console.error(err);
        }
        setLoading(false);
        q.invalidate(keys.write.create(tribunalJobsEntity));
    };
    return (React.createElement("div", null,
        React.createElement("h4", null, lang.tribunal.insolvency),
        React.createElement(DateInput, { allowNull: true, placeholder: lang.tribunal.insolvencyDate, value: insolvencyDate, onChange: (d) => setInsolvencyDate(d) }),
        React.createElement(Button, { onClick: registerInsolvency, loading: loading, block: true }, lang.tribunal.insolvency)));
};
export default RegisterInsolvency;
//# sourceMappingURL=Insolvency.js.map